module.exports = __webpack_public_path__ + "img/IMG_2104.800c37df.jpg";